import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const processMessageProperty = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    name: z
      .string()
      .nullable()
      .optional()
      .requiredFinal()
      .meta({ format: 'camelCase' })
      .describe('Property name'),

    isArray: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether this is an array'),

    required: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether a value is required'),

    description: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Description'),

    sequence: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Display order'),

    messageId: z.uuid().hidden().describe('Foreign key to ProcessMessage'),

    typeId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to ProcessDataType'),

    message: belongsTo('ProcessMessage'),

    type: references('ProcessDataType'),
  })
  .describe('A field carried by a process message.')
  .as('ProcessMessageProperty');

export { processMessageProperty as processMessagePropertySchema };
